export default __webpack_public_path__ + "static/media/favour.3a1728e0.png";